<template>
  <div class="knowbefore-item">
    <div class="knowbefore-item__element knowbefore-item__element--first">
      <vb-icon :name="icon" :color="sass('primary')" :size="16" class="mr-2" />
      <span class="knowbefore-item__title semibold">{{ title }}</span>
    </div>
    <div class="knowbefore-item__element knowbefore-item__element--second">
      <div class="knowbefore-item__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'knowbefore-item',

  components: {
  },

  props: {
    icon: String,
    title: String,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .knowbefore {

    &-item {
      border-bottom: 1px solid $gray-200;
      padding: 20px 0;
      display: flex;
      align-items: flex-start;

      &:last-child {
        border-bottom: 0;
      }

      &__element {

        &--first {
          flex-basis: 20%;
          display: flex;
          align-items: center;
        }
        &--second {
          flex-basis: 80%;
        }
      }

      &__content {

        ::v-deep {

          ul, p {
            margin: 0;
          }

          ul {
            padding-left: $grid-gutter-width / 2;
          }

          ul + * {
            margin-top: $grid-gutter-width / 4;
          }

          li {
            list-style-type: circle;
          }
        }
      }
    }
  }

</style>